import Navbar from 'react-bootstrap/Navbar';
import React from 'react';
import { 
    NavbarContainer,
    NavbarMenu,
    NavbarFlex,
    NavLink,
    ContainerExtend,
    TabDiv,
    ActiveBox
 } from "./style"
import Logo from '../../image/Sequoia_logo_1.png'
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useWindowSize } from '../../hooks/useWindowSize';

const StyledNav = styled.nav`
  position: fixed;  // Makes the navbar stick to the viewport
  top: 0;          // Positions at the top
  left: 0;         // Ensures full width alignment
  right: 0;        // Ensures full width alignment
  width: 100%;     // Full width
  z-index: 1000;   // Ensures navbar stays above other content
  background-color: #fff;  // Or your desired background color
`;

const NavigationBar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { width } = useWindowSize();

  return (
    <StyledNav>
      <NavbarContainer expand="lg">
        <ContainerExtend>
          <Navbar.Brand href="/">
              <img src={Logo} alt="logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <NavbarMenu id="basic-navbar-nav">
            <NavbarFlex>
              <NavLink href="/">
                {width > 992 ? (
                  <ActiveBox 
                    isActive={currentPath === '/'}
                  > 
                    HOME 
                  </ActiveBox>
                ) : (
                  <TabDiv 
                    isActive={currentPath === '/'}
                  >
                    Home
                  </TabDiv> 
                )}
              </NavLink>
              <NavLink href="/practice-area">
                {width > 992 ? (
                  <ActiveBox isActive={currentPath === '/practice-area'}>
                    PRACTICE AREA
                  </ActiveBox>
                ) : (
                  <TabDiv isActive={currentPath === '/practice-area'}>Practice Area</TabDiv> 
                )}
              </NavLink>
              <NavLink href="/our-team">
                {width > 992 ? (
                  <ActiveBox isActive={currentPath === '/our-team'}>
                    OUR TEAM
                  </ActiveBox>
                ) : (
                  <TabDiv isActive={currentPath === '/our-team'}>Our Team</TabDiv> 
                )}
              </NavLink>
              <NavLink href="/article-news">
                {width > 992 ? (
                  <ActiveBox 
                    isActive={currentPath === '/article-news'}
                  >
                    ARTICLE & NEWS
                  </ActiveBox>
                ) : (
                    <TabDiv 
                      isActive={currentPath === '/article-news'}
                    >
                      Article & News
                    </TabDiv> 
                )}
              </NavLink>
              <NavLink href="/contact">
                {width > 992 ? (
                  <ActiveBox 
                    isActive={currentPath === '/contact'}
                  >
                    CONTACT
                  </ActiveBox>
                ) : (
                  <TabDiv isActive={currentPath === '/contact'}>Contact</TabDiv> 
                )}
              </NavLink>
            </NavbarFlex>
          </NavbarMenu>
        </ContainerExtend>
      </NavbarContainer>
    </StyledNav>
  );
}

export default NavigationBar;